import { formatDuration } from '@bingo/shared';

/**
 * Relógio alinhado ao servidor.
 *
 * O telão pode ficar dias ligado e a hora de um mini PC ou Fire TV erra fácil
 * em minutos. Como as durações são calculadas a partir de horários do servidor,
 * um relógio local adiantado mostraria "rodada: 12:43" numa rodada de dois
 * minutos. Então guardamos o offset vindo no `state:sync` e todo cálculo passa
 * por `serverNow()`.
 */

/**
 * Offset do relógio.
 *
 * É estado mutável de módulo lido DURANTE a renderização (`Stage`,
 * `useRevealedRound`) — o mesmo padrão que causou o bug do login. Aqui é
 * seguro, e vale registrar por quê, porque não é óbvio:
 *
 *  · o offset só muda no `state:sync`, que também troca o estado do evento e
 *    já provoca re-renderização;
 *  · os dois leitores têm cadência própria (o relógio do palco a cada segundo,
 *    o `useRevealedRound` no instante da revelação).
 *
 * Se algum dia alguém ler `serverNow()` num componente sem cadência própria e
 * esperar reação à mudança de offset, isto vira store com snapshot, como o
 * `session.ts` e o `voiceStore.ts`.
 */
let offsetMs = 0;

export function syncServerTime(serverTime: string): void {
  const server = new Date(serverTime).getTime();
  if (Number.isFinite(server)) offsetMs = server - Date.now();
}

export function serverNow(): number {
  return Date.now() + offsetMs;
}

export { formatDuration };
